import { message, Switch } from "antd";
import React, { useState } from "react";
import configurationManagementService from "@services/configuationManagement.service";

const Update = ({ item }) => {
  const [loading, setLoading] = useState(false);

  async function changeStatus() {
    setLoading(true);
    try {
      const { data } = configurationManagementService.createAlert({
        ...item,
        enable: !item.enable,
        id: item._id,
      });
    } catch (error) {
      message.error("change status has error");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Switch
      size="small"
      defaultChecked={item.enable}
      onChange={changeStatus}
      loading={loading}
    />
  );
};

export default Update;
